const hasMeaningfulSignalValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "number") return Number.isFinite(value);
    if (typeof value === "boolean") return value;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "object") return Object.keys(value).length > 0;
    return String(value).trim().length > 0;
};

export const hasCommentLegalSignals = (comment = {}) => {
    const signals = comment?.legal_signals || {};
    return (
        hasMeaningfulSignalValue(signals.jurisprudence_trend)
        || hasMeaningfulSignalValue(signals.legal_base_suggestion)
        || hasMeaningfulSignalValue(signals.enforceability_score)
        || hasMeaningfulSignalValue(comment?.jurisprudence)
        || hasMeaningfulSignalValue(comment?.legal_base)
    );
};

export const getLegalSignalComments = (comments = []) => (
    Array.isArray(comments) ? comments.filter(hasCommentLegalSignals) : []
);

export const getFirstLegalSignalComment = (comments = []) => (
    getLegalSignalComments(comments)[0]
);

export const getLegalSignalCommentTarget = (comment = {}) => ({
    id: comment?.id ?? null,
    ref: comment?.ref || comment?.doc_ref || comment?.reference || null,
});

export const buildLegalSignalChipState = (comments = []) => {
    const signalComments = getLegalSignalComments(comments);
    return {
        count: signalComments.length,
        firstComment: signalComments[0] || null,
        firstTarget: getLegalSignalCommentTarget(signalComments[0] || {}),
    };
};
